import { AxiosResponse, AxiosStatic } from "axios";

import * as moment from "moment";

import { FileAnswer } from "@teamprevent/common/questionnaires/model";
import { ImmunisationListModel } from "@teamprevent/common/immunisation/models";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { ImmunisationCreateModel, ImmunisationEditModel, ImmunisationDetailModel, ImmunisationAndEvidenceCreateModel } from "./model";

export class ImmunisationsApi {
    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async getAll(employeeRecordId: string): Promise<ImmunisationListModel[]> {
        const response = await this.axios.get(`/api/employeeRecord/${employeeRecordId}/immunisations`);
        return response.data.map(this.parseModel);
    }

    public async get(employeeRecordId: string, immunisationId: string): Promise<ImmunisationDetailModel> {
        const response = await this.axios.get(`/api/employeeRecord/${employeeRecordId}/immunisations/${immunisationId}`);
        return this.parseModel(response.data);
    }

    public async createImmunisation(
        employeeRecordId: string,
        customerId: string,
        immunisation: ServerModelWithDateStrings<ImmunisationAndEvidenceCreateModel>
    ): Promise<ImmunisationListModel> {
        const response = await this.axios.post(`/api/customer/${customerId}/employeeRecord/${employeeRecordId}/immunisations`, immunisation);
        return this.parseModel(response.data);
    }

    public async createImmunisations(
        employeeRecordId: string,
        customerId: string,
        immunisations: ServerModelWithDateStrings<ImmunisationCreateModel>[],
        evidence: FileAnswer
    ): Promise<void> {
        await this.axios.post<void, AxiosResponse<void>, { immunisations: ServerModelWithDateStrings<ImmunisationCreateModel>[]; evidence: FileAnswer }>(
            `/api/customer/${customerId}/employeeRecord/${employeeRecordId}/immunisations/create-immunisations`,
            { immunisations, evidence }
        );
    }

    public async saveImmunisation(employeeRecordId: string, immunisation: ServerModelWithDateStrings<ImmunisationEditModel>): Promise<ImmunisationListModel> {
        const response = await this.axios.put(`/api/employeeRecord/${employeeRecordId}/immunisations/${immunisation.id}`, immunisation);
        return this.parseModel(response.data);
    }

    public async deleteImmunisation(employeeRecordId: string, id: string): Promise<void> {
        await this.axios.delete(`/api/employeeRecord/${employeeRecordId}/immunisations/${id}`);
    }

    public async sendImmsHistory(customerId: string, employeeRecordId: string): Promise<void> {
        await this.axios.post(`/api/customer/${customerId}/employeeRecord/${employeeRecordId}/immunisations/sendimmshistory`);
    }

    private parseModel = (immunisation: ServerModelWithDateStrings<ImmunisationListModel>): ImmunisationListModel => ({
        ...immunisation,
        dateCompleted: immunisation.dateCompleted && moment(immunisation.dateCompleted)
    });
}
